/* global Accordion */

/**
 * Share Buttons
 */

// Accordion for share buttons only for mobile
const shareContainer = document.querySelector(".social-share");

if( shareContainer !== null ) {

  const accordionShare = new Accordion('.single-actions__share', {
    duration: 400,
    elementClass: "social-share",
    triggerClass: "social-share__header",
    panelClass: "social-share__content",
    openOnInit: [0]
  });

  const handleResize = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 890) {
      accordionShare.attachEvents();
      accordionShare.close(0);
    } else {
      accordionShare.detachEvents();
      accordionShare.open(0);
    }
  };

  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);


}
